var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16.3711L14.9961 1.375H1.375V15.125H15.125V7.00391L16.5 5.62891V16.5H0V0ZM15.9844 2.23438L17.0156 3.26562L8.76562 11.5156L8.25 11.9453L7.73438 11.5156L4.29688 8.07812L5.32812 7.04688L8.25 10.0117L15.9844 2.23438Z",
    fill: "#778CA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckTickIcon);
export default __webpack_public_path__ + "static/media/checkTickIcon.a84485e64922c520dd342641da703673.svg";
export { ForwardRef as ReactComponent };